import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import styles from "./DresserList.module.css";
import { ReactComponent as ArrowRightIcon } from "../assets/icons/arrowRight.svg";
import DresserCard from "./DresserCard";
import defaultImage from "../assets/images/freeface.jpg";
import { getPartners, getTimesheet } from "../services/server-actions";
import { DateTime } from "ts-luxon";
import { StoreService } from "../services/store-service";

interface Dresser {
  id: number;
  name: string;
  service: string;
  date: string;
  avatar: string;
  categories: number[];
  icon?: string;
}

const DresserList: React.FC = () => {
  const navigate = useNavigate();
  const [hairdressers, setHairdressers] = useState<Dresser[]>([]);
  const [categories, setCategories] = useState<any[]>([]);
  const [status, setStatus] = useState<"loading" | "error" | "success">("loading");

  useEffect(() => {
    const fetchData = async () => {
      setStatus("loading");
      try {
        // دریافت دسته‌بندی‌ها
        const storedCategories = StoreService.GetData("categories") || [];
        setCategories(storedCategories);

        // دریافت آرایشگرها
        let storedPartners = StoreService.GetData("partners");

        if (!storedPartners || !Array.isArray(storedPartners)) {
          const fetchedPartners = await getPartners();
          storedPartners = fetchedPartners.map((partner: any) => ({
            id: partner.id,
            firstname: partner.firstname ?? "نامشخص",
            lastname: partner.lastname ?? "نامشخص",
            profile: partner.profile ?? defaultImage,
            categories: partner.categories ?? [],
            icon: partner.icon,
          }));
          StoreService.SetData("partners", storedPartners);
        }

        // دریافت اولین وقت خالی
        const updatedPartners = await Promise.all(
          storedPartners.map(async (partner: any) => {
            let firstAvailableDate: string | null = null;
            for (let i = 0; i < 30; i++) {
              const dateToCheck = DateTime.local().plus({ days: i }).toISODate()!;
              const timesheet = await getTimesheet(dateToCheck, undefined, partner.id);
              if (timesheet && timesheet.length > 0) {
                firstAvailableDate = dateToCheck;
                break;
              }
            }
            return {
              ...partner,
              firstFreeTime: firstAvailableDate,
            };
          })
        );

        const formattedHairdressers = updatedPartners.map((dresser: any) => ({
          id: dresser.id,
          name: `${dresser.firstname || ""} ${dresser.lastname || ""}`.trim() || "نامشخص",
          service:
            dresser.categories
              ?.map((i: any) => storedCategories.find((u: any) => u.id === i)?.name)
              .filter(Boolean)
              .join(", ") || "بدون سرویس",
          date: dresser.firstFreeTime || "نامشخص",
          avatar: dresser.profile || defaultImage,
          categories: dresser.categories || [],
          icon: dresser.icon,
        }));

        setHairdressers(formattedHairdressers);
        setStatus("success");
      } catch (err) {
        console.error("Error fetching dresser data:", err);
        setStatus("error");
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <div className={styles.dresserListPage}>
        <div className={styles.header}>
          <h6 className={styles.title}>آرایشگرها</h6>
          <button className={styles.backButton} onClick={() => navigate("/main")}>
            <ArrowRightIcon className={styles.arrowIcon} />
          </button>
        </div>

        <div className={styles.listContent}>
          {status === "loading" ? (
            <p className="text-center">در حال بارگذاری...</p>
          ) : status === "error" ? (
            <p className="text-center text-danger">خطا در دریافت اطلاعات!</p>
          ) : (
            hairdressers.map((dresser) => (
              <DresserCard key={dresser.id} dresser={dresser} categories={categories} />
            ))
          )}
        </div>
      </div>
    </>
  );
};

export default DresserList;
